import { SOPHIE_STORAGE_KEY } from './consts';
import { SophieData } from './types';

export function isIncognitoMode(): boolean {
  try {
    localStorage.setItem('_test_', '1');
    localStorage.removeItem('_test_');
    return false;
  } catch {
    return true;
  }
}

export function loadSophieData(): SophieData | null {
  try {
    const data = localStorage.getItem(SOPHIE_STORAGE_KEY);
    return data ? JSON.parse(data) : null;
  } catch {
    return null;
  }
}

export function persistSophieData(data: SophieData): void {
  try {
    localStorage.setItem(SOPHIE_STORAGE_KEY, JSON.stringify(data));
  } catch (e) {
    console.error('[Sophie] Failed to save data:', e);
  }
}

export function isValidName(n: unknown): boolean {
  if (!n || typeof n !== 'string') return false;
  if (n.length < 2 || n.length > 20) return false;
  if (/[''\u2018\u2019\u0060]/.test(n)) return false;
  if (
    /^(i'm|im|i'll|i've|i'd|it's|its|he's|she's|we're|they're|don't|let's|that's|there's|here's|what's|who's|how's|can't|won't|isn't|aren't|wasn't|weren't|hasn't|haven't|hadn't|wouldn't|couldn't|shouldn't|doesn't|didn't)$/i.test(
      n
    )
  )
    return false;
  return true;
}

export function getPreferredLanguage(savedLanguage?: string): string {
  if (savedLanguage) return savedLanguage;

  const langs = navigator.languages || [navigator.language];
  const nonEnglish = langs.find((l) => !l.startsWith('en'));
  if (nonEnglish) {
    const code = nonEnglish.split('-')[0];
    if (code === 'ru') return 'Russian';
    if (code === 'uk') return 'Ukrainian';
    if (code === 'zh') return 'Chinese';
  }

  return 'English';
}
